<template>
  <div class="home">
    <el-carousel arrow="never" :interval="2000" :height="height">
      <el-carousel-item v-for="item in imgList" :key="item">
        <img :src="item.src" style="width:100%; cursor:pointer;margin-top: 60px;" @click="goPage('productDetails', 4)"
          v-if="item.name == 'v4'" />
        <img :src="item.src" style="width:100%; cursor:pointer" @click="goPage('productDetails', 2)"
          v-if="item.name == 'v1'" />
        <img :src="item.src" style="width:100%; cursor:pointer" @click="goPage('productDetails', 1)"
          v-if="item.name == 'v2'" />
        <img :src="item.src" style="width:100%; cursor:pointer" @click="goPage('productDetails', 3)"
          v-if="item.name == 'v3'" />

      </el-carousel-item>
    </el-carousel>
    <!-- <img src="../assets/images/phone2.jpg" style="width:100%">  -->
    <!-- <div style="text-align:center; margin-top:100px"> -->
    <!-- <span class="title" style="font-weight:regular">新品上市</span> -->

    <!-- </div> -->
    <div style="display:flex; justify-content:center ">
      <div class="show1" style="background:#E1ECFC ">
        <div class="all">
          <div class="ins">
            <div style="text-align:left">
              <span class="title">NZONE 50 Pro</span><br />
            </div>

            <div style="margin-top:50px">
              <span class="content2">万象星环，视界大开</span>
            </div>

            <div style="display:flex; margin-top:50px">
              <button class="button3" @click="goPage('productDetails', 4)">
                了解更多
              </button>
              <div></div>
              <div class="con">
                <button class="button4" @click="openshop('https://item.jd.com/100035742827.html')">
                  立即购买
                </button>
                <!-- <div class="code">
            <span style="color:black; font-size:12px">请扫描二维码进入移动商城：</span><br>
            <img src="../assets/images/mobilecode.png" style="width:100px; margin-left:25px">
          </div> -->
              </div>
            </div>
          </div>
          <div style="margin-top:150px;margin-left:100px;height:590px">
            <img src="../assets/images/product4/instruct.png" style="width:350px" />
          </div>
        </div>
      </div>
    </div>

    <div style="display:flex; justify-content:center; margin-top: -200px; ">
      <div class="show1">
        <div class="all">
          <div style="margin-top:30px;margin-right:50px">
            <img src="../assets/images/product3/banner.png" style="width:500px" />
          </div>

          <div class="ins">
            <div style="text-align:left">
              <span class="title">NZONE S7</span><br />
            </div>

            <div style="margin-top:50px">
              <!-- <span class="content2">极致美学 全视屏5G手机</span> -->
            </div>

            <div style="display:flex; margin-top:50px">
              <button class="button3" @click="goPage('productDetails', 3)">
                了解更多
              </button>
              <div></div>
              <div class="con">
                <button class="button4" @click="openshop('https://item.jd.com/100031844120.html')">
                  立即购买
                </button>
                <!-- <div class="code">
            <span style="color:black; font-size:12px">请扫描二维码进入移动商城：</span><br>
            <img src="../assets/images/mobilecode.png" style="width:100px; margin-left:25px">
          </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="display:flex; justify-content:center; margin-top:-200px">
      <div class="image">
        <div class="image_content">
          <div class="ins">
            <div style="text-align:left">
              <span class="title">NZONE S7 Pro+ 5G</span><br />
            </div>

            <div style="margin-top:50px">
              <span class="content2">6400万超清四摄 还原世界之美</span>
            </div>

            <div style="display:flex; margin-top:50px">
              <button class="button3" @click="goPage('productDetails', 2)">
                了解更多
              </button>
              <div></div>
              <div class="con">
                <button class="button4" @click="openshop('https://item.jd.com/100028335810.html')">
                  立即购买
                </button>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-right:-200px" v-if="color == 'black'">
          <div style="display:flex; justify-content:center">
            <img src="../assets/images//product2/black.png" style="z-index:2; width:1000px; height:1000px" />
            <img src="../assets/images/product2/black_front.png"
              style="margin-left:-770px;width:1000px; height:1000px; margin-top:-500px" />
          </div>
        </div>

        <div style="margin-right:-200px" v-else-if="color == 'blue'">
          <div style="display:flex; justify-content:center">
            <img src="../assets/images//product2/blue.png" style="z-index:2; width:1000px; height:1000px" />
            <img src="../assets/images/product2/blue_front.png"
              style="margin-left:-770px;width:1000px; height:1000px; margin-top:-500px" />
          </div>
        </div>

        <div style="margin-right:-200px" v-else>
          <div style="display:flex; justify-content:center">
            <img src="../assets/images//product2/purple.png" style="z-index:2; width:1000px; height:1000px" />
            <img src="../assets/images/product2/purple_front.png"
              style="margin-left:-770px;width:1000px; height:1000px; margin-top:-500px" />
          </div>
        </div>

        <div class="choose">
          <div class="choose_item" @click="changecolor('purple')">
            <img src="../assets/images/product2/purplecircle.png" style="width:25px" />
            <div style="margin-left:15px; cursor:pointer">
              <span>月光银</span>
            </div>
          </div>
          <div class="choose_item" @click="changecolor('blue')">
            <img src="../assets/images/product2/bluecircle.png" style="width:25px" />
            <div style="margin-left:15px; cursor:pointer">
              <span>星空蓝</span>
            </div>
          </div>

          <div class="choose_item" @click="changecolor('black')">
            <img src="../assets/images/product2/blackcircle.png" style="width:25px" />
            <div style="margin-left:15px; cursor:pointer">
              <span>优雅黑</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="display:flex; justify-content:center">
      <div class="show">
        <div class="all">
          <div style="margin-top:30px;margin-right:50px">
            <img src="../assets/images/index_phone.png" style="width:600px" />
          </div>

          <div class="ins">
            <div style="text-align:left">
              <span class="title">NZONE S7 Pro 5G</span><br />
            </div>

            <div style="margin-top:50px">
              <span class="content2">极致美学 全视屏5G手机</span>
            </div>

            <div style="display:flex; margin-top:50px">
              <button class="button3" @click="goPage('productDetails', 1)">
                了解更多
              </button>
              <div></div>
              <div class="con">
                <button class="button4" @click="openshop('https://item.jd.com/100015461303.html')">
                  立即购买
                </button>
                <!-- <div class="code">
            <span style="color:black; font-size:12px">请扫描二维码进入移动商城：</span><br>
            <img src="../assets/images/mobilecode.png" style="width:100px; margin-left:25px">
          </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="text-align:center">
      <span class="banner_title">更多服务</span>
    </div>


    <el-carousel arrow="never" :interval="2000" height="750px">
      <el-carousel-item>
        <div class="banner1">
          <div class="ins" style="position:absolute; left:20%; top:20%">
            <div style="text-align:left">
              <span class="title">手机日常终端服务</span><br />
            </div>

            <div style="margin-top:50px">
              <span class="content2">享三项服务内容</span>
            </div>

            <div style="display:flex; margin-top:50px">
              <button class="button3" @click="goPage1('activity1')">了解更多</button>
              <div></div>
            </div>
          </div>

          <img src="../assets/images/activitybanner1.png" style="position:absolute; top: 5%;left:30%; width:65%" />
        </div>



      </el-carousel-item>
      <el-carousel-item>
        <div class="banner">
          <div class="ins" style="position : absolute; left:20%; top:20%">
            <div style="text-align:left">
              <span class="title">手机服务日活动</span><br />
            </div>

            <div style="margin-top:50px">
              <span class="content2">享四项免费权益</span>
            </div>

            <div style="display:flex; margin-top:50px">
              <button class="button3" @click="goPage1('activity')">了解更多</button>
              <div></div>
            </div>
          </div>

          <img src="../assets/images/banner.png" />
        </div>


      </el-carousel-item>

    </el-carousel>


  </div>
</template>

<script lang="ts">
import { onBeforeMount, ref, defineComponent } from "vue";
// import phone2 from "@/assets/images/phone2.jpg";
// import instruction1 from "@/assets/images/instruction1.jpg";

import carousel1 from "@/assets/images/carousel6.jpg";
import carousel2 from "@/assets/images/carousel2.jpg";
import carousel3 from "@/assets/images/carousel3.png";
import carousel4 from '@/assets/images/carousel7.jpg';
import * as api from "../api/apt";
interface imgListProp {
  name: string;
  src: string;
  title?: string;
}

const hadelInput = () => {
  const inputVla = ref("");
  return inputVla;
};

export default defineComponent({
  methods: {
    changecolor(item) {
      this.color = item;
    },
    goPage(path, id) {
      this.$router.push({ name: path, params: { id: id } });
      window.scrollTo(0, 0);
    },

    goPage1(path) {
      this.$router.push({ name: path });
      window.scrollTo(0, 0);
    },

    getHeight() {
      this.height = this.height = (window.innerWidth * 2842) / 4997 - 50 + "px";
      console.log(this.height)
    },

    getProductList() {
      api.getProductList().then(res => {
        sessionStorage.setItem("pId", res.data.result.results[0].id);
      });
    },
    openshop(url) {
      window.open(url);
    }
  },

  data() {
    return {
      height: "",
      color: "purple"
    };
  },

  mounted() {
    this.getHeight();
    window.addEventListener("resize", this.getHeight);
    this.getProductList();
  },

  setup() {
    let imgList = ref<imgListProp[] | null>(null);
    const result = hadelInput();
    onBeforeMount(() => {
      imgList.value = [
        {
          name: "v4",
          src: carousel4,
          title: "v4"
        },
        {
          name: "v3",
          src: carousel1,
          title: "v3"
        },
        {
          name: "v1",
          src: carousel3,
          title: "v1"
        },
        {
          name: "v2",
          src: carousel2,
          title: "v2"
        },

      ];
    });
    return { result, imgList };
  }
});
</script>

<style scoped>
.content {
  font-size: 28px;
  font-style: SourceHanSansSC-bold;
  color: #101010 10000%;
  font-weight: bold;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.img {
  display: flex;
  justify-content: center;
}

.content1 {
  margin-top: 25px;
  display: flex;
  justify-content: center;
}

:deep() .el-carousel {
  z-index: 0;

  height: 100%;
}

:deep().is-active .el-carousel__button {
  width: 15px;
  height: 15px;
  background-color: white;
  border-radius: 15px;
  margin: 3.5px;
  margin-bottom: 0;
}

:deep().el-carousel__indicator--horizontal .el-carousel__button {
  width: 15px;
  height: 15px;
  background-color: white;
  border-radius: 15px;
  margin: 3.5px;
  margin-bottom: 0;
}

.title {
  font-size: 48px;
  font-style: SourceHanSansSC-regular;
  font-weight: bold;
  white-space: nowrap;
}

.show {
  margin-top: 75px;
  width: 80%;
  margin-bottom: 200px;
  /* height: 600px; */
  background-color: #fdf3e7;
  display: flex;
  justify-content: center;
  border-radius: 30px;
  min-width: 1350px;
  padding-right: 40px;
}

.show1 {
  margin-top: 75px;
  width: 80%;
  margin-bottom: 200px;
  /* height: 600px; */
  background-color: #d1e5e4;
  display: flex;
  justify-content: center;
  border-radius: 30px;
  min-width: 1350px;
  padding-right: 40px;
}

.content2 {
  font-size: 28px;
  font-style: SourceHanSansSC-regular;
  white-space: nowrap;
}

.ins {
  max-width: 715px;
  text-align: left;
}

.all {
  display: flex;
  justify-content: space-around;
  max-width: 1250px;
  align-items: center;
}

.button3 {
  background-color: black;
  color: white;
  width: 120px;
  height: 45px;
  font-size: 20px;
  cursor: pointer;
}

.button3:hover {
  background-color: white;
  color: black;
  width: 120px;
  height: 45px;
  font-size: 20px;
  cursor: pointer;
}

.button4 {
  background-color: transparent;
  color: black;
  width: 110px;
  height: 35px;
  font-size: 20px;
  margin-top: 5px;
  margin-left: 15px;
  border-top: black;
  border-left: black;
  border-right: black;
  cursor: pointer;
}

.code {
  display: none;
  margin-left: -30px;
}

.con:hover .code {
  display: block;
  margin-left: -5px;
  margin-top: 20px;
}

.con {
  height: 150px;
}

/* .image {
  height: 603px;
  min-width: 1100px;
  width: 1440px;
  position: relative;
  background-image: url("../assets/images/background.png");
  background-repeat: no-repeat;
  background-position-x: 55%;
  margin-top: 90px;
  padding-top: 150px;
  padding-left: 150px;
} */

.image {
  height: 603px;
  margin-top: 90px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  min-width: 1350px;
  /* padding-left: 100px; */
  padding-right: 40px;
  position: relative;
  background-color: #e3eafd;
  width: 80%;
  border-radius: 30px;
}

.image_content {
  margin-top: 150px;
  margin-right: -250px;
}

.choose {
  /* position: absolute; */
  /* margin-right: 200px; */
  margin-left: -250px;
  margin-top: 430px;
  z-index: 3;
}

.choose_item {
  display: flex;
  justify-content: space-around;
  justify-content: center;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: black;
  cursor: pointer;
}

.banner_title {
  font-size: 40px;
  font-family: "SourceHanSansSC-regular";
  color: #101010;
}

.banner {
  margin-top: 50px;
  margin-bottom: 50px;
  display: flex;
  justify-content: center;
  /* width: 100%; */
  background-color: #ececec;
  padding-top: 50px;
  padding-bottom: 50px;
  height: 600px;
  position: relative;
}

.banner1 {
  margin-top: 50px;
  margin-bottom: 50px;
  display: flex;
  justify-content: center;
  /* width: 100%; */
  background-color: #E5EDFF;
  padding-top: 50px;
  padding-bottom: 50px;
  height: 100%;
  position: relative;
}

.banner_inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
